  //说明书资源
  let TOZO_pdf_https_ja = 'https://s3-us.tozostore.com/tozo/pdfRenderer/web/'
  let Anybuds_pdf_https_ja = 'https://s3-prod.anybuds.com/pdfRenderer/web/'
  let UserManual_ja = 'UserManual'
  let QuickGuide_ja = 'QuickGuide'

  let TOZO_ja = 'TOZO'
  let Anybuds_ja = 'Anybuds'
  let language = 'ja'

  // TOZO
  let UserManual_preview_TOZO_Url = `${TOZO_pdf_https_ja}index.html?file=docs/${UserManual_ja}/${TOZO_ja}/`//预览用户指南
  let UserManual_download_TOZO_Url = `${TOZO_pdf_https_ja}docs/${UserManual_ja}/${TOZO_ja}/` //下载用户指南

  let QuickGuide_preview_TOZO_Url = `${TOZO_pdf_https_ja}index.html?file=docs/${QuickGuide_ja}/${TOZO_ja}/`//预览快速指引
  let QuickGuide_download_TOZO_Url = `${TOZO_pdf_https_ja}docs/${QuickGuide_ja}/${TOZO_ja}/` //下载快速指引

  // Anybuds
  let UserManual_preview_Anybuds_Url= `${Anybuds_pdf_https_ja}index.html?file=docs/${UserManual_ja}/${Anybuds_ja}/`//预览用户指南
  let UserManual_download_Anybuds_Url = `${Anybuds_pdf_https_ja}docs/${UserManual_ja}/${Anybuds_ja}/` //下载用户指南

  let QuickGuide_preview_Anybuds_Url = `${Anybuds_pdf_https_ja}index.html?file=docs/${QuickGuide_ja}/${Anybuds_ja}/`//预览快速指引
  let QuickGuide_download_Anybuds_Url = `${Anybuds_pdf_https_ja}docs/${QuickGuide_ja}/${Anybuds_ja}/` //下载快速指引
  
  // https://s3-us.tozostore.com/tozo/pdfRenderer/web/docs/QuickGuide/TOZO/T6.pdf
  // https://s3-us.tozostore.com/tozo/pdfRenderer/web/index.html?file=docs/UserManual/TOZO/T6.pdf
  // https://s3-prod.anybuds.com/pdfRenderer/web/index.html?file=docs/UserManual/Anybuds/Clips.pdf

  let manualsList_ja = [
    {
      id:31,
      productId: 'TOZO_A1_new',
      productName: 'TOZO A1_new',
      productImg: 'https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_A1.png?v=1740017051',
      UserManual_title:'TOZO A1_new User Manual',
      UserManual_preview_TOZO_Url: `${UserManual_preview_TOZO_Url}A1_new_${language}.pdf`,
      UserManual_download_TOZO_Url: `${UserManual_download_TOZO_Url}A1_new_${language}.pdf`,
      // QuickGuide_title:'TOZO A1_new Quick Guide',
      // QuickGuide_preview_TOZO_Url: `${QuickGuide_preview_TOZO_Url}A1_new_${language}.pdf`,
      // QuickGuide_download_TOZO_Url: `${QuickGuide_download_TOZO_Url}A1_new_${language}.pdf`,
      update_time:''
    },
    {
      id:28,
      productId: 'TOZO_NC9_new',
      productName: 'TOZO NC9_new',
      productImg: 'https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_NC9_new.png?v=1739168680',
      UserManual_title:'TOZO NC9_new User Manual',
      UserManual_preview_TOZO_Url: `${UserManual_preview_TOZO_Url}NC9_new_${language}.pdf`,
      UserManual_download_TOZO_Url: `${UserManual_download_TOZO_Url}NC9_new_${language}.pdf`,
      // QuickGuide_title:'TOZO NC9_new Quick Guide',
      // QuickGuide_preview_TOZO_Url: `${QuickGuide_preview_TOZO_Url}NC9_new_${language}.pdf`,
      // QuickGuide_download_TOZO_Url: `${QuickGuide_download_TOZO_Url}NC9_new_${language}.pdf`,
      update_time:''
    },
    {
      id:25,
      productId: 'TOZO_NC3',
      productName: 'TOZO NC3',
      productImg: 'https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_NC3.png?v=1739168680',
      UserManual_title:'TOZO NC3 User Manual',
      UserManual_preview_TOZO_Url: `${UserManual_preview_TOZO_Url}NC3_${language}.pdf`,
      UserManual_download_TOZO_Url: `${UserManual_download_TOZO_Url}NC3_${language}.pdf`,
      // QuickGuide_title:'TOZO NC3 Quick Guide',
      // QuickGuide_preview_TOZO_Url: `${QuickGuide_preview_TOZO_Url}NC3_${language}.pdf`,
      // QuickGuide_download_TOZO_Url: `${QuickGuide_download_TOZO_Url}NC3_${language}.pdf`,
      update_time:''
    },
    {
      id:29,
      productId: 'TOZO_NC20',
      productName: 'TOZO NC20',
      productImg: 'https://cdn.shopify.com/s/files/1/0737/0578/3585/files/NC20_ja.jpg?v=1761618617',
      UserManual_title:'TOZO NC20 User Manual',
      UserManual_preview_TOZO_Url: `${UserManual_preview_TOZO_Url}NC20_${language}.pdf`,
      UserManual_download_TOZO_Url: `${UserManual_download_TOZO_Url}NC20_${language}.pdf`,
      // QuickGuide_title:'TOZO NC20 Quick Guide',
      // QuickGuide_preview_TOZO_Url: `${QuickGuide_preview_TOZO_Url}NC20_${language}.pdf`,
      // QuickGuide_download_TOZO_Url: `${QuickGuide_download_TOZO_Url}NC20_${language}.pdf`,
      update_time:''
    },
    {
      id:30,
      productId: 'TOZO_Crystal_Pods',
      productName: 'TOZO Crystal Pods',
      productImg: 'https://www.tozostore.com/cdn/shop/files/crystal-pods-main01_5000x.webp?v=1737697775',
      UserManual_title:'TOZO Crystal Pods User Manual',
      UserManual_preview_TOZO_Url: `${UserManual_preview_TOZO_Url}Crystal_Pods_${language}.pdf`,
      UserManual_download_TOZO_Url: `${UserManual_download_TOZO_Url}Crystal_Pods_${language}.pdf`,
      // QuickGuide_title:'TOZO NC9_new Quick Guide',
      // QuickGuide_preview_TOZO_Url: `${QuickGuide_preview_TOZO_Url}Crystal_Pods_${language}.pdf`,
      // QuickGuide_download_TOZO_Url: `${QuickGuide_download_TOZO_Url}Crystal_Pods_${language}.pdf`,
      update_time:''
    },
    {
      id:10,
      productId: 'TOZO_T6_new',
      productName: 'TOZO T6',
      productImg: 'https://cdn.shopify.com/s/files/1/0737/0578/3585/files/01_f4b71ce5-b32e-44c5-95a3-d3f8b9bc25ca_200x.webp?v=1710325942',
      UserManual_title:'TOZO T6 User Manual',
      UserManual_preview_TOZO_Url: `${UserManual_preview_TOZO_Url}T6_new_${language}.pdf`,
      UserManual_download_TOZO_Url: `${UserManual_download_TOZO_Url}T6_new_${language}.pdf`,
      // QuickGuide_title:'TOZO T6 Quick Guide',
      // QuickGuide_preview_TOZO_Url: `${QuickGuide_preview_TOZO_Url}T6_new_${language}.pdf`,
      // QuickGuide_download_TOZO_Url: `${QuickGuide_download_TOZO_Url}T6_new_${language}.pdf`,
      update_time:''
    },
    {
      id:13,
      productId: 'TOZO_T10',
      productName: 'TOZO T10',
      productImg: 'https://cdn.shopify.com/s/files/1/0737/0578/3585/files/T10black_1_200x.webp?v=1688033436',
      UserManual_title:'TOZO T10 User Manual',
      UserManual_preview_TOZO_Url: `${UserManual_preview_TOZO_Url}T10_new_${language}.pdf`,
      UserManual_download_TOZO_Url: `${UserManual_download_TOZO_Url}T10_new_${language}.pdf`,
      // QuickGuide_title:'TOZO T10 Quick Guide',
      // QuickGuide_preview_TOZO_Url: `${QuickGuide_preview_TOZO_Url}T10_new_${language}.pdf`,
      // QuickGuide_download_TOZO_Url: `${QuickGuide_download_TOZO_Url}T10_new_${language}.pdf`,
      update_time:''
    },
    {
      id:5,
      productId: 'TOZO_HT3',
      productName: 'TOZO HT3',
      productImg: 'https://cdn.shopify.com/s/files/1/0737/0578/3585/files/HT3_ja.jpg?v=1761618616',
      UserManual_title:'TOZO HT3 User Manual',
      UserManual_preview_TOZO_Url: `${UserManual_preview_TOZO_Url}HT3_${language}.pdf`,
      UserManual_download_TOZO_Url: `${UserManual_download_TOZO_Url}HT3_${language}.pdf`,
      // QuickGuide_title:'TOZO HT2 Quick Guide',
      // QuickGuide_preview_TOZO_Url: `${QuickGuide_preview_TOZO_Url}HT3_${language}.pdf`,
      // QuickGuide_download_TOZO_Url: `${QuickGuide_download_TOZO_Url}HT3_${language}.pdf`,
      update_time:''
    },
    {
      id:4,
      productId: 'TOZO_HT2',
      productName: 'TOZO HT2',
      productImg: 'https://cdn.shopify.com/s/files/1/0737/0578/3585/files/HT2_Black_200x.jpg?v=1711175324',
      UserManual_title:'TOZO HT2 User Manual',
      UserManual_preview_TOZO_Url: `${UserManual_preview_TOZO_Url}HT2_${language}.pdf`,
      UserManual_download_TOZO_Url: `${UserManual_download_TOZO_Url}HT2_${language}.pdf`,
      // QuickGuide_title:'TOZO HT2 Quick Guide',
      // QuickGuide_preview_TOZO_Url: `${QuickGuide_preview_TOZO_Url}HT2_${language}.pdf`,
      // QuickGuide_download_TOZO_Url: `${QuickGuide_download_TOZO_Url}HT2_${language}.pdf`,
      update_time:''
    },
    {
      id:37,
      productId: 'TOZO_E2',
      productName: 'TOZO E2',
      productImg: 'https://cdn.shopify.com/s/files/1/0737/0578/3585/files/TOZO_E2.png?v=1731750501',
      UserManual_title:'TOZO E2 User Manual',
      UserManual_preview_TOZO_Url: `${UserManual_preview_TOZO_Url}E2_${language}.pdf`,
      UserManual_download_TOZO_Url: `${UserManual_download_TOZO_Url}E2_${language}.pdf`,
      // QuickGuide_title:'TOZO E2 Quick Guide',
      // QuickGuide_preview_TOZO_Url: `${QuickGuide_preview_TOZO_Url}E2_${language}.pdf`,
      // QuickGuide_download_TOZO_Url: `${QuickGuide_download_TOZO_Url}E2_${language}.pdf`,
      update_time:''
    },
    {
      id:36,
      productId: 'TOZO_E1',
      productName: 'TOZO E1',
      productImg: 'https://cdn.shopify.com/s/files/1/0737/0578/3585/files/E1_ja.jpg?v=1761618616',
      UserManual_title:'TOZO E1 User Manual',
      UserManual_preview_TOZO_Url: `${UserManual_preview_TOZO_Url}E1_${language}.pdf`,
      UserManual_download_TOZO_Url: `${UserManual_download_TOZO_Url}E1_${language}.pdf`,
      // QuickGuide_title:'TOZO E2 Quick Guide',
      // QuickGuide_preview_TOZO_Url: `${QuickGuide_preview_TOZO_Url}E1_${language}.pdf`,
      // QuickGuide_download_TOZO_Url: `${QuickGuide_download_TOZO_Url}E1_${language}.pdf`,
      update_time:''
    },

    {
      id:32,
      productId: 'TOZO_A1',
      productName: 'TOZO A1',
      productImg: 'https://www.tozostore.com/cdn/shop/files/tozo-a1-black_400x.jpg?v=1724904650',
      UserManual_title:'TOZO A1 User Manual',
      UserManual_preview_TOZO_Url: `${UserManual_preview_TOZO_Url}A1_${language}.pdf`,
      UserManual_download_TOZO_Url: `${UserManual_download_TOZO_Url}A1_${language}.pdf`,
      // QuickGuide_title:'TOZO A1 Quick Guide',
      // QuickGuide_preview_TOZO_Url: `${QuickGuide_preview_TOZO_Url}A1_${language}.pdf`,
      // QuickGuide_download_TOZO_Url: `${QuickGuide_download_TOZO_Url}A1_${language}.pdf`,
      update_time:''
    },
    {
      id:1,
      productId: 'TOZO_Golden_X1',
      productName: 'TOZO Golden X1',
      productImg: 'https://cdn.shopify.com/s/files/1/0737/0578/3585/files/2fda20546e66829a7a78772086f998f6_200x.jpg?v=1722392434',
      UserManual_title:'TOZO Golden X1 User Manual',
      UserManual_preview_TOZO_Url: `${UserManual_preview_TOZO_Url}X1_${language}.pdf`,
      UserManual_download_TOZO_Url: `${UserManual_download_TOZO_Url}X1_${language}.pdf`,
      // QuickGuide_title:'TOZO Golden X1 Quick Guide',
      // QuickGuide_preview_TOZO_Url: `${QuickGuide_preview_TOZO_Url}X1_${language}.pdf`,
      // QuickGuide_download_TOZO_Url: `${QuickGuide_download_TOZO_Url}X1_${language}.pdf`,
      update_time:''
    },
    // {
    //   id:2,
    //   productId: 'TOZO_HA1',
    //   productName: 'TOZO HA1',
    //   productImg: 'https://cdn.shopify.com/s/files/1/0737/0578/3585/files/tozo-ha1-headphones-1_c36b97e4-5ec6-4d68-9e19-7e35ea78ff89_200x.jpg?v=1726656177',
    //   UserManual_title:'TOZO HA1 User Manual',
    //   UserManual_preview_TOZO_Url: `${UserManual_preview_TOZO_Url}HA1_${language}.pdf`,
    //   UserManual_download_TOZO_Url: `${UserManual_download_TOZO_Url}HA1_${language}.pdf`,
    //   // QuickGuide_title:'TOZO HA1 Quick Guide',
    //   // QuickGuide_preview_TOZO_Url: `${QuickGuide_preview_TOZO_Url}HA1_${language}.pdf`,
    //   // QuickGuide_download_TOZO_Url: `${QuickGuide_download_TOZO_Url}HA1_${language}.pdf`,
    //   update_time:''
    // },
    // {
    //   id:3,
    //   productId: 'TOZO_HT1',
    //   productName: 'TOZO HT1',
    //   productImg: 'https://cdn.shopify.com/s/files/1/0737/0578/3585/files/TOZO_HT1.png?v=1731750501',
    //   // UserManual_title:'TOZO HT1 User Manual',
    //   // UserManual_preview_TOZO_Url: `${UserManual_preview_TOZO_Url}HT1_${language}.pdf`,
    //   // UserManual_download_TOZO_Url: `${UserManual_download_TOZO_Url}HT1_${language}.pdf`,
    //   QuickGuide_title:'TOZO HA1 Quick Guide',
    //   QuickGuide_preview_TOZO_Url: `${QuickGuide_preview_TOZO_Url}HT1_${language}.pdf`,
    //   QuickGuide_download_TOZO_Url: `${QuickGuide_download_TOZO_Url}HT1_${language}.pdf`,
    //   update_time:''
    // },
    // {
    //   id:6,
    //   productId: 'TOZO_Open_Buds',
    //   productName: 'TOZO Open Buds',
    //   productImg: 'https://cdn.shopify.com/s/files/1/0737/0578/3585/files/2023-9-20_200x.jpg?v=1695216089',
    //   UserManual_title:'TOZO Open Buds User Manual',
    //   UserManual_preview_TOZO_Url: `${UserManual_preview_TOZO_Url}Open_Buds_${language}.pdf`,
    //   UserManual_download_TOZO_Url: `${UserManual_download_TOZO_Url}Open_Buds_${language}.pdf`,
    //   QuickGuide_title:'TOZO Open Buds Quick Guide',
    //   QuickGuide_preview_TOZO_Url: `${QuickGuide_preview_TOZO_Url}Open_Buds_${language}.pdf`,
    //   QuickGuide_download_TOZO_Url: `${QuickGuide_download_TOZO_Url}Open_Buds_${language}.pdf`,
    //   update_time:''
    // },
    {
      id:7,
      productId: 'TOZO_Open_Real',
      productName: 'TOZO OpenReal',
      productImg: 'https://cdn.shopify.com/s/files/1/0737/0578/3585/files/6391ace427ade714b70fb966024ae804_200x.jpg?v=1692091037',
      UserManual_title:'TOZO OpenReal User Manual',
      UserManual_preview_TOZO_Url: `${UserManual_preview_TOZO_Url}Open_Real_${language}.pdf`,
      UserManual_download_TOZO_Url: `${UserManual_download_TOZO_Url}Open_Real_${language}.pdf`,
      // QuickGuide_title:'TOZO OpenReal Quick Guide',
      // QuickGuide_preview_TOZO_Url: `${QuickGuide_preview_TOZO_Url}Open_Real_${language}.pdf`,
      // QuickGuide_download_TOZO_Url: `${QuickGuide_download_TOZO_Url}Open_Real_${language}.pdf`,
      update_time:''
    },
    // {
    //   id:8,
    //   productId: 'TOZO_Open_Ego',
    //   productName: 'TOZO OpenEgo',
    //   productImg: 'https://cdn.shopify.com/s/files/1/0737/0578/3585/files/61JYxOoDqvL._AC_SL1500_200x.jpg?v=1712907802',
    //   UserManual_title:'TOZO OpenEgo User Manual',
    //   UserManual_preview_TOZO_Url: `${UserManual_preview_TOZO_Url}Open_Ego_${language}.pdf`,
    //   UserManual_download_TOZO_Url: `${UserManual_download_TOZO_Url}Open_Ego_${language}.pdf`,
    //   QuickGuide_title:'TOZO OpenEgo Quick Guide',
    //   QuickGuide_preview_TOZO_Url: `${QuickGuide_preview_TOZO_Url}Open_Ego_${language}.pdf`,
    //   QuickGuide_download_TOZO_Url: `${QuickGuide_download_TOZO_Url}Open_Ego_${language}.pdf`,
    //   update_time:''
    // },

    {
      id:9,
      productId: 'TOZO_Open_EarRing',
      productName: 'TOZO Open EarRing',
      productImg: 'https://cdn.shopify.com/s/files/1/0737/0578/3585/files/tozo-open-earring.png?v=1728989140',
      UserManual_title:'TOZO Open EarRing User Manual',
      UserManual_preview_TOZO_Url: `${UserManual_preview_TOZO_Url}Open_EarRing_${language}.pdf`,
      UserManual_download_TOZO_Url: `${UserManual_download_TOZO_Url}Open_EarRing_${language}.pdf`,
      // QuickGuide_title:'TOZO Open EarRing Quick Guide',
      // QuickGuide_preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}Open_EarRing_${language}.pdf`,
      // QuickGuide_download_TOZO_Url: `${QuickGuide_download_TOZO_Url}Open_EarRing_${language}.pdf`,
      update_time:''
    },

    // {
    //   id:11,
    //   productId: 'TOZO_T6',
    //   productName: 'TOZO T6',
    //   productImg: 'https://cdn.shopify.com/s/files/1/0737/0578/3585/files/01_f4b71ce5-b32e-44c5-95a3-d3f8b9bc25ca_200x.webp?v=1710325942',
    //   UserManual_title:'TOZO T6 User Manual',
    //   UserManual_preview_TOZO_Url: `${UserManual_preview_TOZO_Url}T6_${language}.pdf`,
    //   UserManual_download_TOZO_Url: `${UserManual_download_TOZO_Url}T6_${language}.pdf`,
    //   QuickGuide_title:'TOZO T6 Quick Guide',
    //   QuickGuide_preview_TOZO_Url: `${QuickGuide_preview_TOZO_Url}T6_${language}.pdf`,
    //   QuickGuide_download_TOZO_Url: `${QuickGuide_download_TOZO_Url}T6_${language}.pdf`,
    //   update_time:''
    // },
    // {
    //   id:12,
    //   productId: 'TOZO_T6_Mini',
    //   productName: 'TOZO T6 Mini',
    //   productImg: 'https://cdn.shopify.com/s/files/1/0737/0578/3585/files/01_f4b71ce5-b32e-44c5-95a3-d3f8b9bc25ca_200x.webp?v=1710325942',
    //   UserManual_title:'TOZO T6 Mini User Manual',
    //   UserManual_preview_TOZO_Url: `${UserManual_preview_TOZO_Url}T6_Mini_${language}.pdf`,
    //   UserManual_download_TOZO_Url: `${UserManual_download_TOZO_Url}T6_Mini_${language}.pdf`,
    //   QuickGuide_title:'TOZO T6 Mini Quick Guide',
    //   QuickGuide_preview_TOZO_Url: `${QuickGuide_preview_TOZO_Url}T6_Mini_${language}.pdf`,
    //   QuickGuide_download_TOZO_Url: `${QuickGuide_download_TOZO_Url}T6_Mini_${language}.pdf`,
    //   update_time:''
    // },
    // {
    //   id:14,
    //   productId: 'TOZO_T10',
    //   productName: 'TOZO T10',
    //   productImg: 'https://cdn.shopify.com/s/files/1/0737/0578/3585/files/T10black_1_200x.webp?v=1688033436',
    //   UserManual_title:'TOZO T10 User Manual',
    //   UserManual_preview_TOZO_Url: `${UserManual_preview_TOZO_Url}T10_${language}.pdf`,
    //   UserManual_download_TOZO_Url: `${UserManual_download_TOZO_Url}T10_${language}.pdf`,
    //   QuickGuide_title:'TOZO T10 Quick Guide',
    //   QuickGuide_preview_TOZO_Url: `${QuickGuide_preview_TOZO_Url}T10_${language}.pdf`,
    //   QuickGuide_download_TOZO_Url: `${QuickGuide_download_TOZO_Url}T10_${language}.pdf`,
    //   update_time:''
    // },
    // {
    //   id:15,
    //   productId: 'TOZO_T10_Mini',
    //   productName: 'TOZO T10 Mini',
    //   productImg: 'https://cdn.shopify.com/s/files/1/0737/0578/3585/files/T10black_1_200x.webp?v=1688033436',
    //   UserManual_title:'TOZO T10 Mini User Manual',
    //   UserManual_preview_TOZO_Url: `${UserManual_preview_TOZO_Url}T10_Mini_${language}.pdf`,
    //   UserManual_download_TOZO_Url: `${UserManual_download_TOZO_Url}T10_Mini.pdf`,
    //   QuickGuide_title:'TOZO T10 Mini Quick Guide',
    //   QuickGuide_preview_TOZO_Url: `${QuickGuide_preview_TOZO_Url}T10_Mini_${language}.pdf`,
    //   QuickGuide_download_TOZO_Url: `${QuickGuide_download_TOZO_Url}T10_Mini_${language}.pdf`,
    //   update_time:''
    // },
    // {
    //   id:16,
    //   productId: 'TOZO_T9',
    //   productName: 'TOZO T9',
    //   productImg: 'https://www.tozostore.com/cdn/shop/files/77ad065df0cdbabb08cf4475f046f61b_4236e04d-0614-4249-b087-06ae0ffcb997_400x.webp?v=1687955062',
    //   UserManual_title:'TOZO T9 User Manual',
    //   UserManual_preview_TOZO_Url: `${UserManual_preview_TOZO_Url}T9_${language}.pdf`,
    //   UserManual_download_TOZO_Url: `${UserManual_download_TOZO_Url}T9_${language}.pdf`,
    //   QuickGuide_title:'TOZO T9 Quick Guide',
    //   QuickGuide_preview_TOZO_Url: `${QuickGuide_preview_TOZO_Url}T9_${language}.pdf`,
    //   QuickGuide_download_TOZO_Url: `${QuickGuide_download_TOZO_Url}T9_${language}.pdf`,
    //   update_time:''
    // },
    {
      id:17,
      productId: 'TOZO_T12',
      productName: 'TOZO T12',
      productImg: 'https://cdn.shopify.com/s/files/1/0737/0578/3585/files/DarkBlack-01_200x.webp?v=1687955316',
      UserManual_title:'TOZO T12 User Manual',
      UserManual_preview_TOZO_Url: `${UserManual_preview_TOZO_Url}T12_${language}.pdf`,
      UserManual_download_TOZO_Url: `${UserManual_download_TOZO_Url}T12_${language}.pdf`,
      // QuickGuide_title:'TOZO T12 Quick Guide',
      // QuickGuide_preview_TOZO_Url: `${QuickGuide_preview_TOZO_Url}T12_${language}.pdf`,
      // QuickGuide_download_TOZO_Url: `${QuickGuide_download_TOZO_Url}T12_${language}.pdf`,
      update_time:''
    },
    // {
    //   id:18,
    //   productId: 'TOZO_T12_Pro',
    //   productName: 'TOZO T12 Pro',
    //   productImg: 'https://cdn.shopify.com/s/files/1/0737/0578/3585/files/T12Pro_1_200x.webp?v=1687955482',
    //   UserManual_title:'TOZO T12 Pro User Manual',
    //   UserManual_preview_TOZO_Url: `${UserManual_preview_TOZO_Url}T12_Pro_${language}.pdf`,
    //   UserManual_download_TOZO_Url: `${UserManual_download_TOZO_Url}T12_Pro_${language}.pdf`,
    //   QuickGuide_title:'TOZO T12 Pro Quick Guide',
    //   QuickGuide_preview_TOZO_Url: `${QuickGuide_preview_TOZO_Url}T12_Pro_${language}.pdf`,
    //   QuickGuide_download_TOZO_Url: `${QuickGuide_download_TOZO_Url}T12_Pro_${language}.pdf`,
    //   update_time:''
    // },
    {
      id:19,
      productId: 'TOZO_T20',
      productName: 'TOZO T20',
      productImg: 'https://cdn.shopify.com/s/files/1/0737/0578/3585/files/9.28-1_200x.webp?v=1696932232',
      UserManual_title:'TOZO T20 User Manual',
      UserManual_preview_TOZO_Url: `${UserManual_preview_TOZO_Url}T20_${language}.pdf`,
      UserManual_download_TOZO_Url: `${UserManual_download_TOZO_Url}T20_${language}.pdf`,
      // QuickGuide_title:'TOZO T20 Quick Guide',
      // QuickGuide_preview_TOZO_Url: `${QuickGuide_preview_TOZO_Url}T20_${language}.pdf`,
      // QuickGuide_download_TOZO_Url: `${QuickGuide_download_TOZO_Url}T20_${language}.pdf`,
      update_time:''
    },
    {
      id:20,
      productId: 'TOZO_T21',
      productName: 'TOZO T21',
      productImg: '	https://cdn.shopify.com/s/files/1/0737/0578/3585/files/Black-01_200x.jpg?v=1709892219',
      UserManual_title:'TOZO T21 User Manual',
      UserManual_preview_TOZO_Url: `${UserManual_preview_TOZO_Url}T21_${language}.pdf`,
      UserManual_download_TOZO_Url: `${UserManual_download_TOZO_Url}T21_${language}.pdf`,
      // QuickGuide_title:'TOZO T21 Quick Guide',
      // QuickGuide_preview_TOZO_Url: `${QuickGuide_preview_TOZO_Url}T21_${language}.pdf`,
      // QuickGuide_download_TOZO_Url: `${QuickGuide_download_TOZO_Url}T21_${language}.pdf`,
      update_time:''
    },
    // {
    //   id:21,
    //   productId: 'TOZO_Tonal_Dots',
    //   productName: 'TOZO Tonal Dots',
    //   productImg: 'https://cdn.shopify.com/s/files/1/0737/0578/3585/files/T12mini_200x.webp?v=1696919111',
    //   UserManual_title:'TOZO Tonal Dots User Manual',
    //   UserManual_preview_TOZO_Url: `${UserManual_preview_TOZO_Url}Tonal_Dots_${language}.pdf`,
    //   UserManual_download_TOZO_Url: `${UserManual_download_TOZO_Url}Tonal_Dots_${language}.pdf`,
    //   QuickGuide_title:'TOZO Tonal Dots Quick Guide',
    //   QuickGuide_preview_TOZO_Url: `${QuickGuide_preview_TOZO_Url}Tonal_Dots_${language}.pdf`,
    //   QuickGuide_download_TOZO_Url: `${QuickGuide_download_TOZO_Url}Tonal_Dots_${language}.pdf`,
    //   update_time:''
    // },
    // {
    //   id:22,
    //   productId: 'TOZO_Tonal_Fits',
    //   productName: 'TOZO Tonal Fits',
    //   productImg: '	https://cdn.shopify.com/s/files/1/0737/0578/3585/files/Black-01_200x.jpg?v=1709892219',
    //   UserManual_title:'TOZO Tonal Fits User Manual',
    //   UserManual_preview_TOZO_Url: `${UserManual_preview_TOZO_Url}Tonal_Fits_${language}.pdf`,
    //   UserManual_download_TOZO_Url: `${UserManual_download_TOZO_Url}Tonal_Fits_${language}.pdf`,
    //   QuickGuide_title:'TOZO Tonal Fits Quick Guide',
    //   QuickGuide_preview_TOZO_Url: `${QuickGuide_preview_TOZO_Url}Tonal_Fits_${language}.pdf`,
    //   QuickGuide_download_TOZO_Url: `${QuickGuide_download_TOZO_Url}Tonal_Fits_${language}.pdf`,
    //   update_time:''
    // },
    {
      id:23,
      productId: 'TOZO_Crystal_Buds',
      productName: 'TOZO Crystal Buds',
      productImg: 'https://cdn.shopify.com/s/files/1/0737/0578/3585/files/01_a514b5f1-aaea-4150-bf45-219e6104772f_200x.webp?v=1687955541',
      UserManual_title:'TOZO Crystal Buds User Manual',
      UserManual_preview_TOZO_Url: `${UserManual_preview_TOZO_Url}Crystal_Buds_${language}.pdf`,
      UserManual_download_TOZO_Url: `${UserManual_download_TOZO_Url}Crystal_Buds_${language}.pdf`,
      // QuickGuide_title:'TOZO Crystal Buds Quick Guide',
      // QuickGuide_preview_TOZO_Url: `${QuickGuide_preview_TOZO_Url}Crystal_Buds_${language}.pdf`,
      // QuickGuide_download_TOZO_Url: `${QuickGuide_download_TOZO_Url}Crystal_Buds_${language}.pdf`,
      update_time:''
    },
    {
      id:24,
      productId: 'TOZO_NC2',
      productName: 'TOZO NC2',
      productImg: 'https://cdn.shopify.com/s/files/1/0737/0578/3585/files/nav_NC2.png?v=1722477828',
      UserManual_title:'TOZO NC2 User Manual',
      UserManual_preview_TOZO_Url: `${UserManual_preview_TOZO_Url}NC2_${language}.pdf`,
      UserManual_download_TOZO_Url: `${UserManual_download_TOZO_Url}NC2_${language}.pdf`,
      // QuickGuide_title:'TOZO NC2 Quick Guide',
      // QuickGuide_preview_TOZO_Url: `${QuickGuide_preview_TOZO_Url}NC2_${language}.pdf`,
      // QuickGuide_download_TOZO_Url: `${QuickGuide_download_TOZO_Url}NC2_${language}.pdf`,
      update_time:''
    },

    {
      id:26,
      productId: 'TOZO_NC7',
      productName: 'TOZO NC7',
      productImg: 'https://cdn.shopify.com/s/files/1/0737/0578/3585/files/MatteBlack-01_400x.jpg?v=1702365906',
      UserManual_title:'TOZO NC7 User Manual',
      UserManual_preview_TOZO_Url: `${UserManual_preview_TOZO_Url}NC7_${language}.pdf`,
      UserManual_download_TOZO_Url: `${UserManual_download_TOZO_Url}NC7_${language}.pdf`,
      // QuickGuide_title:'TOZO NC7 Quick Guide',
      // QuickGuide_preview_TOZO_Url: `${QuickGuide_preview_TOZO_Url}NC7_${language}.pdf`,
      // QuickGuide_download_TOZO_Url: `${QuickGuide_download_TOZO_Url}NC7_${language}.pdf`,
      update_time:''
    },
    {
      id:27,
      productId: 'TOZO_NC9',
      productName: 'TOZO NC9',
      productImg: 'https://cdn.shopify.com/s/files/1/0737/0578/3585/files/Black-01_477d3518-fdfb-472c-b06e-d203bed62c8b_200x.webp?v=1689402133',
      UserManual_title:'TOZO NC9 User Manual',
      UserManual_preview_TOZO_Url: `${UserManual_preview_TOZO_Url}NC9_${language}.pdf`,
      UserManual_download_TOZO_Url: `${UserManual_download_TOZO_Url}NC9_${language}.pdf`,
      // QuickGuide_title:'TOZO NC9 Quick Guide',
      // QuickGuide_preview_TOZO_Url: `${QuickGuide_preview_TOZO_Url}NC9_${language}.pdf`,
      // QuickGuide_download_TOZO_Url: `${QuickGuide_download_TOZO_Url}NC9_${language}.pdf`,
      update_time:''
    },
    // {
    //   id:33,
    //   productId: 'TOZO_A2',
    //   productName: 'TOZO A2',
    //   productImg: 'https://cdn.shopify.com/s/files/1/0737/0578/3585/files/1_fe256af4-68e2-4615-8b18-3fe3bbc0643f_200x.webp?v=1687954523',
    //   UserManual_title:'TOZO A2 User Manual',
    //   UserManual_preview_TOZO_Url: `${UserManual_preview_TOZO_Url}A2_${language}.pdf`,
    //   UserManual_download_TOZO_Url: `${UserManual_download_TOZO_Url}A2_${language}.pdf`,
    //   QuickGuide_title:'TOZO A2 Quick Guide',
    //   QuickGuide_preview_TOZO_Url: `${QuickGuide_preview_TOZO_Url}A2_${language}.pdf`,
    //   QuickGuide_download_TOZO_Url: `${QuickGuide_download_TOZO_Url}A2_${language}.pdf`,
    //   update_time:''
    // },
    // {
    //   id:34,
    //   productId: 'TOZO_A3',
    //   productName: 'TOZO A3',
    //   productImg: 'https://cdn.shopify.com/s/files/1/0737/0578/3585/files/51gofMvmGRL._AC_SL1500_200x.webp?v=1687954631',
    //   UserManual_title:'TOZO A3 User Manual',
    //   UserManual_preview_TOZO_Url: `${UserManual_preview_TOZO_Url}A3_${language}.pdf`,
    //   UserManual_download_TOZO_Url: `${UserManual_download_TOZO_Url}A3_${language}.pdf`,
    //   QuickGuide_title:'TOZO A3 Quick Guide',
    //   QuickGuide_preview_TOZO_Url: `${QuickGuide_preview_TOZO_Url}A3_${language}.pdf`,
    //   QuickGuide_download_TOZO_Url: `${QuickGuide_download_TOZO_Url}A3_${language}.pdf`,
    //   update_time:''
    // },
    // {
    //   id:35,
    //   productId: 'TOZO_E1',
    //   productName: 'TOZO E1',
    //   productImg: 'https://cdn.shopify.com/s/files/1/0737/0578/3585/files/TOZO_E1.png?v=1731750501',
    //   UserManual_title:'TOZO E1 User Manual',
    //   UserManual_preview_TOZO_Url: `${UserManual_preview_TOZO_Url}E1_${language}.pdf`,
    //   UserManual_download_TOZO_Url: `${UserManual_download_TOZO_Url}E1_${language}.pdf`,
    //   QuickGuide_title:'TOZO E1 Quick Guide',
    //   QuickGuide_preview_TOZO_Url: `${QuickGuide_preview_TOZO_Url}E1_${language}.pdf`,
    //   QuickGuide_download_TOZO_Url: `${QuickGuide_download_TOZO_Url}E1_${language}.pdf`,
    //   update_time:''
    // },
    // {
    //   id:38,
    //   productId: 'TOZO_O2',
    //   productName: 'TOZO O2',
    //   productImg: 'https://cdn.shopify.com/s/files/1/0737/0578/3585/files/TOZO_O2.png?v=1731750501',
    //   UserManual_title:'TOZO O2 User Manual',
    //   UserManual_preview_TOZO_Url: `${UserManual_preview_TOZO_Url}O2_${language}.pdf`,
    //   UserManual_download_TOZO_Url: `${UserManual_download_TOZO_Url}O2_${language}.pdf`,
    //   QuickGuide_title:'TOZO O2 Quick Guide',
    //   QuickGuide_preview_TOZO_Url: `${QuickGuide_preview_TOZO_Url}O2_${language}.pdf`,
    //   QuickGuide_download_TOZO_Url: `${QuickGuide_download_TOZO_Url}O2_${language}.pdf`,
    //   update_time:''
    // },
    // {
    //   id:39,
    //   productId: 'TOZO_Color_Pods',
    //   productName: 'TOZO Color Pods',
    //   productImg: 'https://cdn.shopify.com/s/files/1/0737/0578/3585/files/Color_Pods.png?v=1731750501',
    //   UserManual_title:'TOZO Color Pods User Manual',
    //   UserManual_preview_TOZO_Url: `${UserManual_preview_TOZO_Url}Color_Pods_${language}.pdf`,
    //   UserManual_download_TOZO_Url: `${UserManual_download_TOZO_Url}Color_Pods_${language}.pdf`,
    //   // QuickGuide_title:'TOZO Color Pods Quick Guide',
    //   // QuickGuide_preview_TOZO_Url: `${QuickGuide_preview_TOZO_Url}Color_Pods_${language}.pdf`,
    //   // QuickGuide_download_TOZO_Url: `${QuickGuide_download_TOZO_Url}Color_Pods_${language}.pdf`,
    //   update_time:''
    // },
    // {
    //   id:40,
    //   productId: 'TOZO_Watch1',
    //   productName: 'TOZO Watch1',
    //   productImg: 'https://cdn.shopify.com/s/files/1/0737/0578/3585/files/TOZO_Watch1.png?v=1731750502',
    //   UserManual_title:'TOZO Watch1 User Manual',
    //   UserManual_preview_TOZO_Url: `${UserManual_preview_TOZO_Url}Watch1_${language}.pdf`,
    //   UserManual_download_TOZO_Url: `${UserManual_download_TOZO_Url}Watch1_${language}.pdf`,
    //   // QuickGuide_title:'TOZO Watch1 Quick Guide',
    //   // QuickGuide_preview_TOZO_Url: `${QuickGuide_preview_TOZO_Url}Watch1_${language}.pdf`,
    //   // QuickGuide_download_TOZO_Url: `${QuickGuide_download_TOZO_Url}Watch1_${language}.pdf`,
    //   update_time:''
    // },
    {
      id:41,
      productId: 'TOZO_S2',
      productName: 'TOZO S2',
      productImg: 'https://www.tozostore.com/cdn/shop/files/MatterBlack44mm-01_400x.webp?v=1687959415',
      UserManual_title:'TOZO S2 User Manual',
      UserManual_preview_TOZO_Url: `${UserManual_preview_TOZO_Url}S2_${language}.pdf`,
      UserManual_download_TOZO_Url: `${UserManual_download_TOZO_Url}S2_${language}.pdf`,
      // QuickGuide_title:'TOZO S2 Quick Guide',
      // QuickGuide_preview_TOZO_Url: `${QuickGuide_preview_TOZO_Url}S2_${language}.pdf`,
      // QuickGuide_download_TOZO_Url: `${QuickGuide_download_TOZO_Url}S2_${language}.pdf`,
      update_time:''
    },
    {
      id:42,
      productId: 'TOZO_S3',
      productName: 'TOZO S3',
      productImg: 'https://www.tozostore.com/cdn/shop/files/1_19e9bbf1-8534-43a1-bab4-a561f06963d2_300x.jpg?v=1715418934',
      UserManual_title:'TOZO S2 User Manual',
      UserManual_preview_TOZO_Url: `${UserManual_preview_TOZO_Url}S3_${language}.pdf`,
      UserManual_download_TOZO_Url: `${UserManual_download_TOZO_Url}S3_${language}.pdf`,
      // QuickGuide_title:'TOZO S2 Quick Guide',
      // QuickGuide_preview_TOZO_Url: `${QuickGuide_preview_TOZO_Url}S3_${language}.pdf`,
      // QuickGuide_download_TOZO_Url: `${QuickGuide_download_TOZO_Url}S3_${language}.pdf`,
      update_time:''
    },
    {
      id:43,
      productId: 'TOZO_S4',
      productName: 'TOZO S4',
      productImg: 'https://www.tozostore.com/cdn/shop/files/71Te7dr13HL._AC_SL1500_300x.jpg?v=1706525266',
      UserManual_title:'TOZO S2 User Manual',
      UserManual_preview_TOZO_Url: `${UserManual_preview_TOZO_Url}S4_${language}.pdf`,
      UserManual_download_TOZO_Url: `${UserManual_download_TOZO_Url}S4_${language}.pdf`,
      // QuickGuide_title:'TOZO S2 Quick Guide',
      // QuickGuide_preview_TOZO_Url: `${QuickGuide_preview_TOZO_Url}S4_${language}.pdf`,
      // QuickGuide_download_TOZO_Url: `${QuickGuide_download_TOZO_Url}S4_${language}.pdf`,
      update_time:''
    },
    {
      id:44,
      productId: 'TOZO_S5',
      productName: 'TOZO S5',
      productImg: 'https://www.tozostore.com/cdn/shop/files/E0F611FA-0458-4918-8C2E-21B8E1E1C4E6_400x.png?v=1718451274',
      UserManual_title:'TOZO S5 User Manual',
      UserManual_preview_TOZO_Url: `${UserManual_preview_TOZO_Url}S5_${language}.pdf`,
      UserManual_download_TOZO_Url: `${UserManual_download_TOZO_Url}S5_${language}.pdf`,
      // QuickGuide_title:'TOZO S5 Quick Guide',
      // QuickGuide_preview_TOZO_Url: `${QuickGuide_preview_TOZO_Url}S5_${language}.pdf`,
      // QuickGuide_download_TOZO_Url: `${QuickGuide_download_TOZO_Url}S5_${language}.pdf`,
      update_time:''
    },
    // {
    //   id:45,
    //   productId: 'TOZO_AcuFit_Lite',
    //   productName: 'TOZO AcuFit Lite',
    //   productImg: 'https://www.tozostore.com/cdn/shop/files/1_19e9bbf1-8534-43a1-bab4-a561f06963d2_400x.jpg?v=1715418934',
    //   UserManual_title:'TOZO AcuFit Lite User Manual',
    //   UserManual_preview_TOZO_Url: `${UserManual_preview_TOZO_Url}AcuFit_Lite_${language}.pdf`,
    //   UserManual_download_TOZO_Url: `${UserManual_download_TOZO_Url}AcuFit_Lite_${language}.pdf`,
    //   // QuickGuide_title:'TOZO AcuFit Lite Quick Guide',
    //   // QuickGuide_preview_TOZO_Url: `${QuickGuide_preview_TOZO_Url}AcuFit_Lite_${language}.pdf`,
    //   // QuickGuide_download_TOZO_Url: `${QuickGuide_download_TOZO_Url}AcuFit_Lite_${language}.pdf`,
    //   update_time:''
    // },
    // {
    //   id:46,
    //   productId: 'TOZO_AcuFit_One',
    //   productName: 'TOZO AcuFit One',
    //   productImg: 'https://www.tozostore.com/cdn/shop/files/71Te7dr13HL._AC_SL1500_400x.jpg?v=1706525266',
    //   UserManual_title:'TOZO AcuFit One User Manual',
    //   UserManual_preview_TOZO_Url: `${UserManual_preview_TOZO_Url}AcuFit_One_${language}.pdf`,
    //   UserManual_download_TOZO_Url: `${UserManual_download_TOZO_Url}AcuFit_One_${language}.pdf`,
    //   // QuickGuide_title:'TOZO AcuFit One Quick Guide',
    //   // QuickGuide_preview_TOZO_Url: `${QuickGuide_preview_TOZO_Url}AcuFit_One_${language}.pdf`,
    //   // QuickGuide_download_TOZO_Url: `${QuickGuide_download_TOZO_Url}AcuFit_One_${language}.pdf`,
    //   update_time:''
    // },
    // {
    //   id:47,
    //   productId: 'TOZO_AcuFit_GT',
    //   productName: 'TOZO AcuFit GT',
    //   productImg: '	https://www.tozostore.com/cdn/shop/files/E0F611FA-0458-4918-8C2E-21B8E1E1C4E6_400x.png?v=1718451274',
    //   UserManual_title:'TOZO AcuFit GT User Manual',
    //   UserManual_preview_TOZO_Url: `${UserManual_preview_TOZO_Url}AcuFit_GT_${language}.pdf`,
    //   UserManual_download_TOZO_Url: `${UserManual_download_TOZO_Url}AcuFit_GT_${language}.pdf`,
    //   // QuickGuide_title:'TOZO AcuFit GT Quick Guide',
    //   // QuickGuide_preview_TOZO_Url: `${QuickGuide_preview_TOZO_Url}AcuFit_GT_${language}.pdf`,
    //   // QuickGuide_download_TOZO_Url: `${QuickGuide_download_TOZO_Url}AcuFit_GT_${language}.pdf`,
    //   update_time:''
    // },
    // {
    //   id:48,
    //   productId: 'TOZO_AcuFit_Solo',
    //   productName: 'TOZO AcuFit Solo',
    //   productImg: 'https://cdn.shopify.com/s/files/1/0737/0578/3585/files/AcuFit_Solo.png?v=1731750502',
    //   UserManual_title:'TOZO AcuFit Solo User Manual',
    //   UserManual_preview_TOZO_Url: `${UserManual_preview_TOZO_Url}AcuFit_Solo_${language}.pdf`,
    //   UserManual_download_TOZO_Url: `${UserManual_download_TOZO_Url}AcuFit_Solo_${language}.pdf`,
    //   // QuickGuide_title:'TOZO AcuFit Solo Quick Guide',
    //   // QuickGuide_preview_TOZO_Url: `${QuickGuide_preview_TOZO_Url}AcuFit_Solo_${language}.pdf`,
    //   // QuickGuide_download_TOZO_Url: `${QuickGuide_download_TOZO_Url}AcuFit_Solo_${language}.pdf`,
    //   update_time:''
    // },
    // {
    //   id:49,
    //   productId: 'TOZO_AcuFit_Evo',
    //   productName: 'TOZO AcuFit Evo',
    //   productImg: 'https://cdn.shopify.com/s/files/1/0737/0578/3585/files/AcuFit_Evo.png?v=1731750502',
    //   UserManual_title:'TOZO AcuFit Evo User Manual',
    //   UserManual_preview_TOZO_Url: `${UserManual_preview_TOZO_Url}AcuFit_Evo_${language}.pdf`,
    //   UserManual_download_TOZO_Url: `${UserManual_download_TOZO_Url}AcuFit_Evo_${language}.pdf`,
    //   // QuickGuide_title:'TOZO AcuFit Evo Quick Guide',
    //   // QuickGuide_preview_TOZO_Url: `${QuickGuide_preview_TOZO_Url}AcuFit_Evo_${language}.pdf`,
    //   // QuickGuide_download_TOZO_Url: `${QuickGuide_download_TOZO_Url}AcuFit_Evo_${language}.pdf`,
    //   update_time:''
    // },
    // {
    //   id:50,
    //   productId: 'TOZO_PA1',
    //   productName: 'TOZO PA1',
    //   productImg: 'https://www.tozostore.com/cdn/shop/files/01_792d0cef-4538-4788-893e-a067c5f9e03f_400x.webp?v=1687959526',
    //   UserManual_title:'TOZO PA1 User Manual',
    //   UserManual_preview_TOZO_Url: `${UserManual_preview_TOZO_Url}PA1_${language}.pdf`,
    //   UserManual_download_TOZO_Url: `${UserManual_download_TOZO_Url}PA1_${language}.pdf`,
    //   QuickGuide_title:'TOZO PA1 Quick Guide',
    //   QuickGuide_preview_TOZO_Url: `${QuickGuide_preview_TOZO_Url}PA1_${language}.pdf`,
    //   QuickGuide_download_TOZO_Url: `${QuickGuide_download_TOZO_Url}PA1_${language}.pdf`,
    //   update_time:''
    // },
    // {
    //   id:51,
    //   productId: 'TOZO_PE1',
    //   productName: 'TOZO PE1',
    //   productImg: 'https://www.tozostore.com/cdn/shop/files/tozo-pe1-black_400x.jpg?v=1730700525',
    //   UserManual_title:'TOZO PE1 User Manual',
    //   UserManual_preview_TOZO_Url: `${UserManual_preview_TOZO_Url}PE1_${language}.pdf`,
    //   UserManual_download_TOZO_Url: `${UserManual_download_TOZO_Url}PE1_${language}.pdf`,
    //   QuickGuide_title:'TOZO PE1 Quick Guide',
    //   QuickGuide_preview_TOZO_Url: `${QuickGuide_preview_TOZO_Url}PE1_${language}.pdf`,
    //   QuickGuide_download_TOZO_Url: `${QuickGuide_download_TOZO_Url}PE1_${language}.pdf`,
    //   update_time:''
    // },
    // {
    //   id:52,
    //   productId: 'TOZO_W1',
    //   productName: 'TOZO W1',
    //   productImg: 'https://www.tozostore.com/cdn/shop/files/BlackM-100mm-01_400x.webp?v=1687957029',
    //   UserManual_title:'TOZO W1 User Manual',
    //   UserManual_preview_TOZO_Url: `${UserManual_preview_TOZO_Url}W1_${language}.pdf`,
    //   UserManual_download_TOZO_Url: `${UserManual_download_TOZO_Url}W1_${language}.pdf`,
    //   // QuickGuide_title:'TOZO W1 Quick Guide',
    //   // QuickGuide_preview_TOZO_Url: `${QuickGuide_preview_TOZO_Url}W1_${language}.pdf`,
    //   // QuickGuide_download_TOZO_Url: `${QuickGuide_download_TOZO_Url}W1_${language}.pdf`,
    //   update_time:''
    // },
    // {
    //   id:53,
    //   productId: 'TOZO_W6',
    //   productName: 'TOZO W6',
    //   productImg: '	https://www.tozostore.com/cdn/shop/files/DarkBlack65mm-01_400x.webp?v=1687957974',
    //   UserManual_title:'TOZO W6 User Manual',
    //   UserManual_preview_TOZO_Url: `${UserManual_preview_TOZO_Url}W6_${language}.pdf`,
    //   UserManual_download_TOZO_Url: `${UserManual_download_TOZO_Url}W6_${language}.pdf`,
    //   // QuickGuide_title:'TOZO W6 Quick Guide',
    //   // QuickGuide_preview_TOZO_Url: `${QuickGuide_preview_TOZO_Url}W6_${language}.pdf`,
    //   // QuickGuide_download_TOZO_Url: `${QuickGuide_download_TOZO_Url}W6_${language}.pdf`,
    //   update_time:''
    // },
    // {
    //   id:54,
    //   productId: 'TOZO_W10',
    //   productName: 'TOZO W10',
    //   productImg: 'https://www.tozostore.com/cdn/shop/files/1_c30f871c-7852-428e-970d-e0d31532ceb3_400x.webp?v=1687958277',
    //   UserManual_title:'TOZO W10 User Manual',
    //   UserManual_preview_TOZO_Url: `${UserManual_preview_TOZO_Url}W10_${language}.pdf`,
    //   UserManual_download_TOZO_Url: `${UserManual_download_TOZO_Url}W10_${language}.pdf`,
    //   // QuickGuide_title:'TOZO W10 Quick Guide',
    //   // QuickGuide_preview_TOZO_Url: `${QuickGuide_preview_TOZO_Url}W10_${language}.pdf`,
    //   // QuickGuide_download_TOZO_Url: `${QuickGuide_download_TOZO_Url}W10_${language}.pdf`,
    //   update_time:''
    // },


    // Anybuds
    // {
    //   id:55,
    //   productId: 'Anybuds_Clips',
    //   productName: 'Anybuds Clips',
    //   productImg: '',
    //   UserManual_title:'Anybuds Clips User Manual',
    //   UserManual_preview_TOZO_Url: `${UserManual_preview_Anybuds_Url}Clips_${language}.pdf`,
    //   UserManual_download_TOZO_Url: `${UserManual_download_Anybuds_Url}Clips_${language}.pdf`,
    //   QuickGuide_title:'Anybuds Clips Quick Guide',
    //   QuickGuide_preview_TOZO_Url: `${QuickGuide_preview_Anybuds_Url}Clips_${language}.pdf`,
    //   QuickGuide_download_TOZO_Url: `${QuickGuide_download_Anybuds_Url}Clips_${language}.pdf`,
    //   update_time:''
    // },
    // {
    //   id:56,
    //   productId: 'Anybuds_Dots',
    //   productName: 'Anybuds Dots',
    //   productImg: '',
    //   UserManual_title:'Anybuds Dots User Manual',
    //   UserManual_preview_TOZO_Url: `${UserManual_preview_Anybuds_Url}Dots_${language}.pdf`,
    //   UserManual_download_TOZO_Url: `${UserManual_download_Anybuds_Url}Dots_${language}.pdf`,
    //   QuickGuide_title:'Anybuds Dots Quick Guide',
    //   QuickGuide_preview_TOZO_Url: `${QuickGuide_preview_Anybuds_Url}Dots_${language}.pdf`,
    //   QuickGuide_download_TOZO_Url: `${QuickGuide_download_Anybuds_Url}Dots_${language}.pdf`,
    //   update_time:''
    // },
    // {
    //   id:57,
    //   productId: 'Anybuds_Fits',
    //   productName: 'Anybuds Fits',
    //   productImg: '',
    //   // UserManual_title:'Anybuds Fits User Manual',
    //   // UserManual_preview_TOZO_Url: `${UserManual_preview_Anybuds_Url}Fits_${language}.pdf`,
    //   // UserManual_download_TOZO_Url: `${UserManual_download_Anybuds_Url}Fits_${language}.pdf`,
    //   QuickGuide_title:'Anybuds Fits Quick Guide',
    //   QuickGuide_preview_TOZO_Url: `${QuickGuide_preview_Anybuds_Url}Fits_${language}.pdf`,
    //   QuickGuide_download_TOZO_Url: `${QuickGuide_download_Anybuds_Url}Fits_${language}.pdf`,
    //   update_time:''
    // },
    // {
    //   id:58,
    //   productId: 'Anybuds_Pro',
    //   productName: 'Anybuds Pro',
    //   productImg: '',
    //   // UserManual_title:'Anybuds Pro User Manual',
    //   // UserManual_preview_TOZO_Url: `${UserManual_preview_Anybuds_Url}Pro_${language}.pdf`,
    //   // UserManual_download_TOZO_Url: `${UserManual_download_Anybuds_Url}Pro_${language}.pdf`,
    //   QuickGuide_title:'Anybuds Pro Quick Guide',
    //   QuickGuide_preview_TOZO_Url: `${QuickGuide_preview_Anybuds_Url}Pro_${language}.pdf`,
    //   QuickGuide_download_TOZO_Url: `${QuickGuide_download_Anybuds_Url}Pro_${language}.pdf`,
    //   update_time:''
    // },
    // {
    //   id:59,
    //   productId: 'Anybuds_Vivid',
    //   productName: 'Anybuds Vivid',
    //   productImg: '',
    //   // UserManual_title:'Anybuds Vivid User Manual',
    //   // UserManual_preview_TOZO_Url: `${UserManual_preview_Anybuds_Url}Vivid_${language}.pdf`,
    //   // UserManual_download_TOZO_Url: `${UserManual_download_Anybuds_Url}Vivid_${language}.pdf`,
    //   QuickGuide_title:'Anybuds Vivid Quick Guide',
    //   QuickGuide_preview_TOZO_Url: `${QuickGuide_preview_Anybuds_Url}Vivid_${language}.pdf`,
    //   QuickGuide_download_TOZO_Url: `${QuickGuide_download_Anybuds_Url}Vivid_${language}.pdf`,
    //   update_time:''
    // },

  ]

  //自定义的本地数据分页
  function customPaginateData(data, page, perPage) {
    // 确保页数和每页条数是有效的
    page = Math.max(1, page);
    perPage = Math.max(1, perPage);
  
    // 计算总记录数
    const total = data.length;
  
    // 计算总页数
    const lastPage = Math.ceil(total / perPage);
  
    // 计算当前页的开始和结束索引
    const start = (page - 1) * perPage;
    const end = Math.min(start + perPage, total);
  
    // 获取当前页的数据
    const currentPageData = data.slice(start, end);
  
    return {
      current_page: page,
      last_page: lastPage,
      per_page: perPage,
      to: end,
      total: total,
      data: currentPageData
    };
  }